angular.module('bmsApp.merrymaids.job', [
	'ui.router'
])
	.config([
		'$stateProvider',
		function config($stateProvider) {

			$stateProvider

			// ---------- PROFORMA QUOTES START ----------
				.state('main.merrymaids.proformaQuote', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobMain.html'
						}
					}
				})

				.state('main.merrymaids.proformaQuote.create', {
					url: '^/merrymaids/proforma-quote/add/{enquiryId}',
					views: {
						'content@main.merrymaids.proformaQuote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobSave.html',
							controller: 'MMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {
						parent: 'main.crm.enquiry.index.view',
						label: 'Add Proforma Quote'
					}
				})

				.state('main.merrymaids.proformaQuote.read', {
					url: '^/merrymaids/proforma-quote/{jobId}',
					views: {
						'content@main.merrymaids.proformaQuote': {
							templateUrl: 'ng/merrymaids/job/templates/MMQuoteView.html',
							controller: 'MMJobViewCtrl'
						}
					},
					ncyBreadcrumb: {
						parent: 'main.crm.enquiry.index.view',
						label: '{{ job.label }}'
					}
				})

				.state('main.merrymaids.proformaQuote.read.update', {
					url: '/edit',
					views: {
						'content@main.merrymaids.proformaQuote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobSave.html',
							controller: 'MMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {
						parent: 'main.merrymaids.quote.read',
						label: 'Edit Proforma Quote'
					}
				})
				// ---------- PROFORMA QUOTES FINISH ----------



				// ---------- QUOTES START ----------
				.state('main.merrymaids.quote', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobMain.html',
							controller: 'MMJobMainCtrl',
						}
					}
				})

				.state('main.merrymaids.quote.index', {
					url: '^/merrymaids/quotes',
					views: {
						'content@main.merrymaids.quote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobIndex.html',
							controller: 'MMJobIndexCtrl'
						},
						'side@main.merrymaids.quote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobIndexSide.html',
						}
					},
					ncyBreadcrumb: {
						label: 'Quotes'
					}
				})

				.state('main.merrymaids.quote.create', {
					url: '^/merrymaids/quote/add/{customerId}',
					views: {
						'content@main.merrymaids.quote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobSave.html',
							controller: 'MMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {
						parent: 'main.merrymaids.quote.index',
						label: 'Add Quote'
					}
				})

				.state('main.merrymaids.quote.read', {
					url: '^/merrymaids/quote/{jobId}',
					views: {
						'content@main.merrymaids.quote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobView.html',
							controller: 'MMJobViewCtrl'
						}
					},
					ncyBreadcrumb: {
						parent: 'main.merrymaids.quote.index',
						label: '{{ job.label }}'
					}
				})

				.state('main.merrymaids.quote.read.update', {
					url: '/edit',
					views: {
						'content@main.merrymaids.quote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobSave.html',
							controller: 'MMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {
						label: 'Edit Quote'
					}
				})

				.state('main.merrymaids.quote.read.convert', {
					url: '/convert',
					views: {
						'content@main.merrymaids.quote': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobSave.html',
							controller: 'MMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {
						label: 'Convert'
					}
				})
				// ---------- QUOTES FINISH ----------



				// ---------- JOBS START ----------
				.state('main.merrymaids.job', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobMain.html',
							controller: 'MMJobMainCtrl'
						}
					}
				})

				.state('main.merrymaids.job.bulk-inactive', {
					url: '^/merrymaids/jobs/bulk-inactive',
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/bulkInactive/templates/BulkInactive.html',
							controller: 'BulkInactiveCtrl',
							controllerAs: 'BulkInactive',
						},
						'side@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobIndexSide.html',
						}
					},
					ncyBreadcrumb: {
						label: 'Jobs'
					}
				})

				.state('main.merrymaids.job.bulk-inactive-one-off-job', {
					url: '^/merrymaids/jobs/one-off-job-cleanup',
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/bulkInactiveOneOffJob/templates/BulkInactiveOneOffJob.html',
							controller: 'BulkInactiveOneOffJobCtrl',
							controllerAs: 'BulkInactiveOneOffJob',
						},
						'side@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobIndexSide.html',
						}
					},
					ncyBreadcrumb: {
						label: 'Jobs'
					}
				})

				.state('main.merrymaids.job.index', {
					url: '^/merrymaids/jobs',
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobIndex.html',
							controller: 'MMJobIndexCtrl'
						},
						'side@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobIndexSide.html',
						}
					},
					ncyBreadcrumb: {
						label: 'Jobs'
					}
				})

				.state('main.merrymaids.job.read', {
					url: '^/merrymaids/job/{jobId}',
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobView.html',
							controller: 'MMJobViewCtrl'
						}
					},
					ncyBreadcrumb: {
						parent: 'main.merrymaids.job.index',
						label: '{{ job.label }}'
					}
				})

				.state('main.merrymaids.job.read.update', {
					url: '/edit',
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMJobSave.html',
							controller: 'MMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {
						label: 'Edit Job'
					}
				})

				.state('main.merrymaids.job.close', {
					abstract: true
				})

				.state('main.merrymaids.job.close.list', {
					url: '^/merrymaids/jobs/close-jobs',
					params: {
						data: null
					},
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMCloseJobList.html',
							controller: 'MMCloseJobListCtrl'
						},
                        'side@main.merrymaids.job': {
                            templateUrl: 'ng/merrymaids/job/templates/MMCloseJobListSide.html',
                        }
					},
					ncyBreadcrumb: {
						label: 'Close Jobs'
					}
				})

				.state('main.merrymaids.job.close.part', {
					url: '^/merrymaids/jobs/close-job/{jobPartId:int}',
					views: {
						'content@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMCloseJob.html',
							controller: 'MMCloseJobCtrl'
						},
						'side@main.merrymaids.job': {
							templateUrl: 'ng/merrymaids/job/templates/MMCloseJobSide.html',
							controller: 'MMCloseJobSideCtrl',
						}
					},
					ncyBreadcrumb: {
						label: '{{ jobPart.job.customer.label }} (Job Date: {{ jobPart.job_date | amDateFormat:config.format.date.amFullDate }})',
						parent: 'main.merrymaids.job.close.list'
					}
				})
				// ---------- JOBS FINISH ----------

			;

		}
	]);
